import React, { useEffect, useState, memo } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Type from "@actionTypes";
import { Menu } from "antd";
import open from "./img/open.png";
import close from "./img/indent.png";
import confirm from "./img/confirm.png";
import execute from "./img/execute.png";
import mediate from "./img/mediate.png";
import register from "./img/register.png";
import search from "./img/search.png";
import trial from "./img/trial.png";
import "./index.less";
import { filterHasChild } from "@utils/filter";


const SiderMenu = (props) => {
  const { permissionTree } = useSelector((state) => state.app);
  const { menuInfo } = useSelector((state) => state);
  const [openKeys, setOpenKeys] = useState([])
  const { isShowMenu, activeKey, tabsList = [] } = menuInfo;
  const dispatch = useDispatch();
  const changeMenuOpen = () => {
    dispatch({ type: Type.MENU_CHANGE });
  };
  const history = useHistory();
  // 点击子列表
  const openPage = (child, key) => {
    dispatch({
      type: Type.MENU_CLICK,
      child: {
        ...child,
        pathUrl: child.path.substr(6),
        key,
        url: props.casepoolUrl
      },
    })
    history.replace(props.casepoolUrl)
  };

  const iconList = {
    judicialConfirm: confirm,
    executiveBoard: execute,
    mediationCenter: mediate,
    registerCourt: register,
    caseQuery: search,
    trialCourt: trial,
  }
  const menuPerm = permissionTree?.court?.children;
  return (
    <div className="large-menu" style={isShowMenu ? {} : { width: 0 }}>
      <div className="menu-btn" onClick={() => changeMenuOpen(!isShowMenu)}>
        <img src={isShowMenu ? close : open} alt=""/>
      </div>
      {
        !!isShowMenu &&
        <>
          <div className='sider-titel'>数字调解平台</div>
          <Menu
            mode="inline"
            // theme="dark"
            style={{
              backgroundColor: "#fff",
              color: '#333',
              zIndex: 99,
              overflowY: 'auto',
              overflowX: 'hidden',
              height: 'calc(100% - 54px)'
            }}
            inlineCollapsed={!isShowMenu}
            selectedKeys={[menuInfo.activeKey?.split('-')[0]]}   // 详情选中
            onOpenChange={(openKeys) => setOpenKeys(openKeys)}
            openKeys={openKeys}
          >
            {
              // menuList.map((menuItem, index) => (
              Object.keys(menuPerm).map((menuItem, index) => {
                const father = menuPerm[menuItem];

                //校验该菜单下是否有选中
               const hasChild = filterHasChild(father)
                return (
                  <>
                    {hasChild.length > 0 &&
                    <Menu.SubMenu
                      key={menuItem}
                      icon={<img src={iconList[menuItem]} alt=""/>}
                      title={isShowMenu && father.des}
                    >
                      {Object.keys(father.children).map((child) => {
                        const childMenu = father.children[child]
                        const hasChildTemp = filterHasChild(childMenu)
                        if (hasChildTemp.length > 0) {
                          return (
                            <Menu.SubMenu
                              key={child}
                              title={isShowMenu && childMenu.des}
                            >
                              {Object.keys(childMenu.children).map((son) => {
                                const sonMenu = childMenu.children[son]
                                if (sonMenu.perm > 0) {
                                  return (
                                    <Menu.Item
                                      key={son}
                                      onClick={() => openPage(sonMenu, son)}
                                    >
                                      {sonMenu.des}
                                    </Menu.Item>
                                  )
                                }
                              })}
                            </Menu.SubMenu>
                          )
                        }
                      })}
                    </Menu.SubMenu>
                    }
                  </>
                )
              })}
          </Menu>
        </>
      }
    </div>
  );
};

export default memo(SiderMenu);
